import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as unitsData from '../../../assets/multi-regions/multi-regions.json';

@Injectable({
  providedIn: 'root'
})
export class MeasurementsDataService {
  private measurementsData = new BehaviorSubject<string>('');
  getMeasurementsData = this.measurementsData.asObservable();

  setData(measurementsData: string) {
    this.measurementsData.next(measurementsData);
  }

  regionMeasurementUnits(){
    if(this.measurementsData.value === 'METRIC') {
      return unitsData.EU
    }else {
      return unitsData.US
    }
  } 
}
